module.exports = __webpack_public_path__ + "static/media/united-states.2822f086.png";